import React from 'react';
import PropTypes from 'prop-types';
import { ErrorAlert, InfoAlert, WarningAlert } from '@huggg/react-components';

import styles from './types.module.scss';

const Alert = (props) => {
  const { level = 'warning', message } = props.value || {};

  return (
    <div className={styles.typeAlphaAlert}>
      {level === 'warning' ? (
        <WarningAlert message={message} />
      ) : level === 'error' ? (
        <ErrorAlert message={message} />
      ) : (
        <InfoAlert message={message} />
      )}
    </div>
  );
};

Alert.propTypes = {
  value: PropTypes.object.isRequired,
};

export default Alert;
